import React from 'react'
import Product from '../components/Product'

const Home = () => {
  return (
    <div>
      <br /><br /><br /><br /><br />
        <h2>Welcome to our store</h2>
        <section>
            <h3>Product</h3>
            <Product/>
        </section>
    </div>
  )
}

export default Home